export const EL_ID_PORTAL_HEADER_ACTIONS = "portal-header-actions";
export const EL_ID_PORTAL_HEADER_ACTIONS_LEFT = "portal-header-actions-left";
